import { useContentfulLiveUpdates } from "@contentful/live-preview/react"
import FlexibleData from "@lib/flexibleData"
import { getAllNewsData, getCompanyNewsData } from "@lib/api"

import Layout from "../../layout"
import Button from "../../components/button"
import Block from "../../components/block"
import Card from "../../components/card"
import Grid from "../../components/grid"

import {
  announcements_header,
  cards_container,
  button_container,
  news_header
} from "./styles.module.scss"

export async function getStaticProps(context) {
  const preview = process.env.NODE_ENV === "development" || context.draftMode || false
  const previewEnv = context?.previewData?.environment || null

  const data = (await FlexibleData.fetch("newsroom", preview, previewEnv)) ?? []

  const newsData = (await getAllNewsData(preview)).items.slice(0, 3) ?? []
  const announcementsData = (await getCompanyNewsData(preview)).items.slice(0, 3) ?? []

  return {
    props: {
      preview,
      data: data,
      newsData,
      announcementsData
    }
  }
}

const NewsroomPage = ({ preview, data, newsData, announcementsData }) => {
  const pageTitle = "Amperity Newsroom"
  const liveData = useContentfulLiveUpdates(data)
  const blocks = liveData.modulesCollection.items

  return (
    <Layout
      pageTitle={liveData.title}
      excerpt={liveData.excerpt}
      preview={preview}
      featuredImage={liveData.featuredImage}
    >
      <Grid column={1} width="narrow" centerText alignment="center" paddingBottom="small">
        <h1>{pageTitle}</h1>
        <p>
          For media inquiries, you can reach us at&nbsp;
          <a
            href={`mailto:press@amperity.com?subject=Media Inquiry`}
            target="_blank"
            rel="noreferrer noopener"
          >
            press@amperity.com
          </a>
        </p>
      </Grid>

      <div className={announcements_header}>
        <h2>Latest Announcements</h2>
      </div>

      <div className={cards_container}>
        {announcementsData.map((newsPost, index) => {
          return (
            <div key={index}>
              <Card
                key={index}
                theme="hover"
                title={newsPost.title}
                image={{
                  alt: newsPost.featuredImage.description,
                  src: newsPost.featuredImage.url,
                  height: newsPost.featuredImage.height,
                  width: newsPost.featuredImage.width
                }}
                label="Announcement"
                buttonUrl={`/announcements/${newsPost.slug}`}
                startDate={newsPost.date}
              />
            </div>
          )
        })}
      </div>
      <div className={button_container}>
        <Button theme="dark" url="/announcements">
          See all announcements
        </Button>
      </div>

      <div className={news_header}>
        <h2>Amperity in the News</h2>
      </div>

      <div className={cards_container}>
        {newsData.map((newsPost, index) => {
          return (
            <div key={index}>
              <Card
                key={index}
                theme="hover"
                title={newsPost.title}
                image={{
                  alt: newsPost.featuredImage.description,
                  src: newsPost.featuredImage.url,
                  height: newsPost.featuredImage.height,
                  width: newsPost.featuredImage.width
                }}
                label="News"
                buttonUrl={newsPost.link}
                startDate={newsPost.date}
              />
            </div>
          )
        })}
      </div>
      <div className={button_container}>
        <Button theme="dark" url="/in-the-news">
          See all news
        </Button>
      </div>

      {(blocks || []).map((block, idx) => (
        <Block key={idx} template={block?.__typename} {...block} />
      ))}
    </Layout>
  )
}

export default NewsroomPage
